export default __webpack_public_path__ + "static/media/RenderCV_EngineeringResumes_Theme (2).33b6501d.pdf";